import React from "react";
import styled from "styled-components";
import mountainImg from '../HelpSupport/mountain.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FaEnvelope, FaPhone, FaRegCommentDots } from "react-icons/fa";



const HelpSupport = () => {
    return (
        <Wrapper className="container py-5">
            <div className="card border-0 shadow-sm p-4">
                <h4 className="fw-bold text-dark">Help & Support Center</h4>
                <p className="text-muted mb-4">
                    See what users are saying and sharing about the partnered tourist spots.
                </p>

                <div className="row mb-4">
                    <div className="col-12">
                        <img
                            src={mountainImg}
                            alt="Example"
                            className="img-fluid rounded"
                            style={{ width: '100%', height: '400px', objectFit: 'cover' }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="card border-0 p-4" style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                            <h6 className="fw-semibold text-dark mb-4">Frequently Asked Questions</h6>

                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingOne">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                            Accordion Item #1
                                        </button>
                                    </h2>
                                    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            Content for accordion item #1.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                            Accordion Item #2
                                        </button>
                                    </h2>
                                    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            Content for accordion item #2.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingThree">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                            Accordion Item #3
                                        </button>
                                    </h2>
                                    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            Content for accordion item #3.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingFour">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                                            Accordion Item #4
                                        </button>
                                    </h2>
                                    <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            Content for accordion item #4.
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingFive">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                                            Accordion Item #5
                                        </button>
                                    </h2>
                                    <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            Content for accordion item #5.
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="card border-0 p-4" style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', height: '354px' }}>
                            <h6 className="fw-semibold text-dark ">Contact Support</h6>
                            <p className="text-muted mb-4">Can’t find what you're looking for? Reach out to us.</p>
                            <div className="d-flex justify-content-between align-items-center border rounded mb-3 p-2 bg-light">
                                <div className="d-flex align-items-center">
                                    <FaEnvelope className="me-3 text-primary" />
                                    <div className="text-muted small">Email Support</div>
                                </div>
                                <div className="text-muted small">support@venuepass.example.com</div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center border rounded mb-4 p-2 bg-light">
                                <div className="d-flex align-items-center">
                                    <FaPhone className="me-3 text-primary" style={{ transform: 'rotate(90deg)' }} />
                                    <div className="text-muted small">Call Us</div>
                                </div>
                                <div className="text-muted small">+1 (234) 567-890</div>
                            </div>
                            <button className="btn btn-primary text-white w-100 d-flex align-items-center justify-content-center gap-2 mb-3">
                                <FaRegCommentDots /> Submit Feedback or Suggestion
                            </button>
                            <p className="text-muted small mb-0">
                                Our support team is available Monday to Friday, 9 AM - 5 PM (Local Time).<br />
                                We aim to respond to all queries within 24 business hours.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card border-0 p-4 mt-5" style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                <h6 className="fw-semibold text-dark mb-4">UseFul Links & Resource</h6>
                <div className="row g-3">
                    <div className="col-md-4">
                        <div className="p-4 rounded bg-light h-100 shadow-sm">
                            <h6 className="text-black mb-1">Getting Started Guide</h6>
                            <p className="text-muted mb-0 small">New to the portal? Start here.</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-4 rounded bg-light h-100 shadow-sm">
                            <h6 className="text-black mb-1">API Documentation</h6>
                            <p className="text-muted mb-0 small">For developers integrating with our system.</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-4 rounded bg-light h-100 shadow-sm">
                            <h6 className="text-black mb-1">Terms of Service</h6>
                            <p className="text-muted mb-0 small">Review our partner agreement.</p>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default HelpSupport;

const Wrapper = styled.div``;